module.exports = __webpack_public_path__ + "static/media/arrows-bright.58113a13.jpg";